import React from 'react';

const InternationalComingSoon = () => {
  return (
    <div
      style={{
        height: 'calc(100vh - 64px)',
        backgroundColor: '#fff',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        fontSize: 24,
        fontWeight: 600,
      }}
    >
      La zone Internationale sera bientôt disponible.
    </div>
  );
};

export default InternationalComingSoon;
